import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ScreenType } from 'src/app/enums/ScreenType';
import { UserRegDetails } from 'src/app/models/user';
import { Visitor } from 'src/app/models/visitor';

@Component({
  selector: 'app-visitor-invite',
  templateUrl: './visitor-invite.component.html',
  styleUrls: ['./visitor-invite.component.scss'],
})
export class VisitorInviteComponent {
  @Input() selectedDate: Date;
  @Input() hostLists: UserRegDetails[];
  @Input() visitorList: Visitor[];
  @Input() set screen(val: ScreenType) {
    this.screenInfo = val;
  }
  @Output() onCreateNewVisitor = new EventEmitter();
  @Output() onUpdateExistingVisitor = new EventEmitter();
  @Output() onCancelVisitorInvite = new EventEmitter();
  @Output() onVerifyVisitor = new EventEmitter();
  hostMenu: [];
  screenInfo: ScreenType;
  constructor() {}
  createNewVisitor(val: any) {
    val['visitDateTime'] = this.selectedDate;
    this.onCreateNewVisitor.emit(val);
  }
  updateVisitor(val: any) {
    this.onUpdateExistingVisitor.emit(val);
  }
  onClose() {
    this.onCancelVisitorInvite.emit();
  }
  ScreenType = ScreenType;
}
@Component({
  selector: 'agreement',
  templateUrl: 'visitorAgreement.html',
})
export class VisitorAgreement {}
